// Filename: public/BIEventsFunctions.js 
import { biLoggerFactory } from 'wix-private';
 
const msid = 'd9e5a3c3-b5c4-41d0-90d3-6806c264c9a9'; 
 
 

 
export async function fireBIEvent(evid, fields) {
 
    const biLogger = biLoggerFactory('domains', 19, { msid });
    try {
        const biEventObject = {
            evid,
            ...fields
        };
        await biLogger.log(biEventObject);
        console.log('BI Event Fired Successfully with ', biEventObject);
    } catch (err) {
        console.error(`Failed to fireBIEvent -err- ${err}`);
    }
}
